import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const defaultCardsLimit = 50
const defaultCardImgRatio = 'portrait'
const defaultCardAlignment = 'left'

const containerAttribute = '[recently-viewed-container]'
const localStorageSelector = 'AuroraTheme-RecentlyViewed'
const cardTemplateSelector = 'product-card-template'

const cardSelector = 'product-card'
const cardInnerSelector = '[data-product-card-inner]'

export class RecentlyViewed extends BaseComponent {
  cardLimit: number
  cardImgRatio: string
  cardAlignment: string

  cardAlignmentClass: string
  shapeClass: string

  products: HTMLElement[]
  container: HTMLElement

  constructor() {
    super()

    this.cardLimit = +this.dataset.cardLimit ?? defaultCardsLimit
    this.cardImgRatio = this.dataset.imgRatio ?? defaultCardImgRatio
    this.cardAlignment = this.dataset.cardAlignment ?? defaultCardAlignment

    this.cardAlignmentClass = `product-card--${this.cardAlignment}-alignment`
    this.shapeClass = `shape--${this.cardImgRatio}`

    this.products = []
    this.container = $el(containerAttribute, this)
  }

  async mountComponent(): Promise<void> {
    await this.fetchItems()

    if (this.products.length > 0) {
      this.setItems()
      this.setVisible(true)
    }
  }

  fetchItems = async (): Promise<void> => {
    const { origin } = window.location
    const locale = window.Shopify.routes.root ?? '/'

    const currentSavedProducts = JSON.parse(
      localStorage.getItem(localStorageSelector),
    )?.slice(0, this.cardLimit)

    if (!currentSavedProducts) {
      return
    }

    try {
      for (const handle of currentSavedProducts) {
        const section = await fetch(
          `${origin}${locale}products/${handle}?sections=product-card-template`,
        ).then(res => res.json())

        const node = this.createNodeByString(section[cardTemplateSelector])

        if (node) {
          this.products.push(node)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  setItems = (): void => {
    this.container.replaceChildren(...this.products)
  }

  setVisible(isVisible: boolean): void {
    this.classList.toggle('hidden', !isVisible)
  }

  createNodeByString(productString: string): HTMLElement | null {
    const html = new DOMParser().parseFromString(productString, 'text/html')
    const node = $el(`.${cardTemplateSelector}`, html)

    $el(cardSelector, node)?.classList.add(this.cardAlignmentClass)
    $el(cardInnerSelector, node)?.classList.add(this.shapeClass)

    if (this.shapeClass.includes('fit')) {
      $el(cardInnerSelector, node)?.classList.add('shape--fit')
    }

    const productCard = node.querySelector('product-card')

    if (productCard) {
      const slide = document.createElement('div')
      const cardToAdd = productCard.cloneNode(true) as HTMLElement

      slide.classList.add('slider-grid__slide')
      slide.setAttribute('slider-grid-slide', '')
      slide.append(cardToAdd)

      return slide
    } else {
      return null
    }
  }

  static updateProductsInLocalStorage(handle: string): void {
    if (!handle) {
      return
    }

    const currentSavedProducts =
      JSON.parse(localStorage.getItem(localStorageSelector)) ?? []

    const isExist = currentSavedProducts?.find(
      (item: string) => item === handle,
    )

    const newProducts = isExist
      ? currentSavedProducts
      : [handle, ...currentSavedProducts].slice(0, defaultCardsLimit)

    localStorage.setItem(localStorageSelector, JSON.stringify(newProducts))
  }
}
